// src/App.jsx
import AppRouter from "./router/AppRouter";

import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import ThemeProvider from "./context/ThemeContext";
import { Toaster } from "react-hot-toast";
export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <LanguageProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#363636",
                color: "#fff",
              },
              success: {
                duration: 3000,
                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
            }}
          />
          <AppRouter />
        </LanguageProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
